
export const baseUrl = 'https://apilaboratorio.clinicadeolhos.shop/api';
// export const baseUrl = 'http://127.0.0.1:8000/api';